/**
 * 
 */
class ResizeHandler {
    constuctor() {}

    init() {
        this.windowWidth = window.innerWidth
        this.windowHeight = window.innerHeight
        this.widthChangeEventListeners = []
        this.heightChangeEventListeners = []

        window.addEventListener('resize', (event) => {
            if(this.windowWidth !== window.innerWidth) {
                this.windowWidth = window.innerWidth
                this.widthChangeEventListeners.forEach((widthChangeEventListener) => {
                    widthChangeEventListener()
                })
            }
        })

        window.addEventListener('resize', (event) => {
            if(this.windowHeight !== window.innerHeight) {
                this.windowHeight = window.innerHeight
                this.heightChangeEventListeners.forEach((heightChangeEventListener) => {
                    heightChangeEventListener()
                })
            }
        })
    }

    addWidthResizeListener(widthChangeEventListener) {
        this.widthChangeEventListeners.push(widthChangeEventListener)
    }

    addHeightResizeListener(heightChangeEventListener) {
        this.heightChangeEventListeners.push(heightChangeEventListener)
    }
}
export default new ResizeHandler() // return singleton instance
